export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-truck-line',
      title: 'توصيل سريع',
      desc: 'توصيل لجميع دول الخليج خلال 2-5 أيام عمل مضمونة',
      num: '2-5',
      unit: 'أيام',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'دفع آمن 100%',
      desc: 'جميع المعاملات مشفرة ومحمية بأعلى معايير الأمان',
      num: '100%',
      unit: 'أمان',
    },
    {
      icon: 'ri-refresh-line',
      title: 'إرجاع مجاني',
      desc: 'ضمان الإرجاع خلال 14 يوم بدون أي أسئلة',
      num: '14',
      unit: 'يوم',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'دعم متواصل',
      desc: 'فريق خدمة العملاء متاح على مدار الساعة عبر واتساب',
      num: '24/7',
      unit: 'خدمة',
    },
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-[#080808] overflow-hidden relative" dir="rtl">
      {/* Cinematic top/bottom lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#E8721A]/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#E8721A]/20 to-transparent" />

      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="w-16 h-px bg-gradient-to-l from-[#E8721A] to-transparent" />
            <span className="text-[#E8721A] text-xs font-bold tracking-[0.3em] uppercase">لماذا نحن</span>
            <div className="w-16 h-px bg-gradient-to-r from-[#E8721A] to-transparent" />
          </div>
          <h2 className="text-4xl font-black text-white mb-4">خدمة استثنائية في كل خطوة</h2>
          <p className="text-white/30 text-sm max-w-lg mx-auto leading-relaxed">نلتزم بتقديم أفضل تجربة تسوق ممكنة من لحظة الطلب حتى وصول منتجاتك</p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
          {features.map((f, i) => (
            <div
              key={f.title}
              className="group relative bg-[#080808] p-8 overflow-hidden text-right hover:bg-[#0F0F0F] transition-all duration-500"
            >
              {/* Background number */}
              <div className="absolute -top-4 -left-2 text-8xl font-black text-white/3 select-none pointer-events-none">
                {String(i + 1).padStart(2, '0')}
              </div>

              {/* Hover glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#E8721A]/0 to-[#E8721A]/0 group-hover:from-[#E8721A]/5 group-hover:to-transparent transition-all duration-500" />

              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center border border-white/10 group-hover:border-[#E8721A]/50 mb-6 transition-all duration-500 relative">
                <i className={`${f.icon} text-2xl text-white/40 group-hover:text-[#E8721A] transition-colors duration-500`} />
                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#E8721A]/0 group-hover:border-[#E8721A] transition-all duration-500" />
                <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#E8721A]/0 group-hover:border-[#E8721A] transition-all duration-500" />
              </div>

              {/* Stat */}
              <div className="flex items-baseline gap-1 mb-1">
                <span className="text-3xl font-black text-white group-hover:text-[#E8721A] transition-colors duration-500">{f.num}</span>
                <span className="text-xs text-[#E8721A]/60 font-bold tracking-widest uppercase">{f.unit}</span>
              </div>

              <h3 className="text-white/80 font-bold text-sm mb-2 tracking-wide">{f.title}</h3>
              <p className="text-white/30 text-xs leading-relaxed">{f.desc}</p>

              {/* Bottom accent line */}
              <div className="absolute bottom-0 right-0 left-0 h-px bg-[#E8721A] scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-right" />
            </div>
          ))}
        </div>

        {/* Trust badges row */}
        <div className="mt-14 flex flex-wrap items-center justify-center gap-10 pt-10 border-t border-white/5">
          {[
            { icon: 'ri-secure-payment-line', label: 'دفع آمن ومضمون' },
            { icon: 'ri-verified-badge-line', label: 'منتجات أصلية 100%' },
            { icon: 'ri-award-line', label: 'علامة تجارية موثوقة' },
            { icon: 'ri-store-2-line', label: 'متجر معتمد رسمياً' },
          ].map(b => (
            <div key={b.label} className="flex items-center gap-2 text-white/30 hover:text-white/60 transition-colors duration-300">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${b.icon} text-[#E8721A] text-lg`} />
              </div>
              <span className="text-xs font-medium tracking-widest uppercase">{b.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
